<template>
    <div>
        <div class="mention-pos pos-rel"></div>
        <div ref="editorContainer" class="tiptap-editor"></div>
    </div>
</template>
                    
<script>
    import { Editor } from '@tiptap/core';
    import { StarterKit } from '@tiptap/starter-kit';
    import { Mention } from '@tiptap/extension-mention';
    import { Placeholder } from '@tiptap/extension-placeholder'; // Import the placeholder extension
    import $ from "jquery"; 
   import { Extension } from '@tiptap/core';
    const CustomKeyboardShortcuts = Extension.create({
    addKeyboardShortcuts() {
        return {
            'Enter': () => {
                
                const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                if (isMobile) {
                  //  event.preventDefault();
                  this.editor.commands.insertContent('<br>');
                  return true;
                }
                return false; // Default behavior otherwise
            },
        };
    },
});
 
    export default {
        name: 'TiptapEditor',
        props: {
            value: {
                type: String,
                default: '',
            },
            mentions: {
                type: Array,
                default: () => [],
            },
            placeholder: {
                type: String,
                default: 'Type your message here...',
            },
        },
        data() {
            return {
                editor: null,
                suggestionBox: null,
                newVal:null // Store a reference to the suggestion box
            };
        },
        watch: {
            // Watch for changes in the value prop and update the editor content
            value(newVal) {
                console.log('newVal',newVal)
                this.newVal  = newVal;
                this.$nextTick(() => { 
                    const editorContainer = this.$refs.editorContainer;
                    if (editorContainer) {
                         editorContainer.style.height = 'auto'; // Reset height
                         editorContainer.style.height = `${editorContainer.scrollHeight}px`; // Set new height
                         this.$emit('conversation', editorContainer.scrollHeight-50);
                    }
                });
                this.updatePlaceholder();
                // const editorContainer = this.$refs.editorContainer;
                if(newVal == ''){
                    // this.editor.commands.setContent(''); // Clear the editor content if empty
                    // editorContainer.style.height = `50px`;
                    // editorContainer.scrollHeight  = `50px`;
                    // //alert('newVal',editorContainer.style.height);
                    // this.$emit('typingtitleHight', 70); 
                    // this.$emit('conversation', 0); 
                    // this.$emit('uploaderHight', 50);
                }
                if (this.editor && newVal !== this.editor.getHTML()) {
                    // const contentHeight = Math.max(editorContainer.scrollHeight, 50); // Always at least 50px
                    // var dataHeight = Array.from(document.querySelectorAll(".tiptap .editor-paragraph")).reduce((sum, el) => sum + el.offsetHeight, 0);
                    // console.log(">>>>>> ", contentHeight,dataHeight)
                    // const editor = document.getElementsByClassName("ProseMirror")[0];
                    // if (editor) {
                    //     editor.scrollTop = dataHeight;
                    // }
                    // let conversation = contentHeight - 50;
                    // if (conversation < 0) {
                    //     conversation = 0; // Prevent negative bottom value
                    // } 
                    // let typingtitleHight = Math.max(contentHeight, 70); 
                    // this.$emit('uploaderHight', contentHeight); 
                    // this.$emit('typingtitleHight', typingtitleHight); 
                    // this.$emit('conversation', conversation); 
                    //console.log('newVal',newVal);
                    // newVal = newVal.replace(/(?<!<a[^>]*>)(https?:\/\/[^\s<]+)(?!<\/a>)/g, (url) => {
                    //     return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
                    // });
                    this.editor.commands.setContent(newVal);
                }
            },
        },
        mounted() {
            this.editor = new Editor({
                element: this.$refs.editorContainer, // This binds the editor to the container div
                extensions: [
                    CustomKeyboardShortcuts,
                    // StarterKit,
                    StarterKit.configure({
                        paragraph: {
                            HTMLAttributes: {
                                class: 'editor-paragraph',
                            },
                        },
                    }),
                    Mention.configure({
                        HTMLAttributes: {
                            class: 'mention',
                        },
                        suggestion: {
                            char: '@', // The character that triggers the mention
                            items: (query) => {
                                return this.fetchMentions(query); // Fetch mentions based on the query
                            },
                            render: () => {
                                return {
                                    onStart: (props) => this.onStart(props),
                                    onUpdate: (props) => this.onUpdate(props),
                                    onSelect: (props) => this.onSelect(props),
                                };
                            },
                        }
                    }),
                    Placeholder.configure({
                        placeholder: this.placeholder, // Use the placeholder prop
                        emptyNodeClass: 'is-empty', // Add a specific class when empty
                        showOnlyWhenEditable: true, // Show the placeholder only when the editor is editable
                        includeChildren: true, // Include children in empty state detection
                        filter: (node) => {
                            return node.textContent.trim() === ''; // Avoid whitespace-only content being marked empty
                        }
                        // You can also customize other properties like the class name, etc.
                    }),
                ],
                content: this.value || '', // Set the initial content
            });
            this.editor.on('change', (instance) => {
                alert('asasasas');
                console.log('Message edited:', instance.getValue());
            });
            // Sync content to v-model whenever the editor content changes
            this.editor.on('update', () => {
                let updatedContent = this.editor.getHTML();
                updatedContent = updatedContent.replace(/(https?:\/\/[^\s<]+)/g, (url) => {
                                    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
                                });
                $('.tiptap p.is-empty').each(function() {
                     if($('.tiptap p').length > 1){
                        $(this).html('<p class="editor-paragraph"><br class="ProseMirror-trailingBreak"></p>');
                        $(this).remove();
                      }
                });
               
                this.$emit('input', updatedContent); // Sync content back to parent component
                this.$emit('change'); // Emit the @change event with the updated content
                const editorContainer = this.$refs.editorContainer;
                let contentHeight = editorContainer.scrollHeight;
                // console.log("scroll height:", editorContainer.scrollHeight)
                const minHeight = 50;
                contentHeight = Math.max(contentHeight, minHeight); 
                editorContainer.style.height = `${contentHeight}px`;
                if(updatedContent == '<p class="editor-paragraph"></p>'){
                    this.editor.commands.setContent(''); // Clear the editor content if empty
                    editorContainer.style.height = `${minHeight}px`;
                    this.$emit('typingtitleHight', 70); 
                    this.$emit('conversation', 0); 
                    this.$emit('uploaderHight', minHeight);
                }else{
                    // document.querySelector('.ProseMirror').style.height = `${contentHeight}px`;
                    const contentHeight = Math.max(editorContainer.scrollHeight, minHeight); // Always at least 50px
                    var dataHeight = Array.from(document.querySelectorAll(".tiptap .editor-paragraph")).reduce((sum, el) => sum + el.offsetHeight, 0);
                    // console.log(">>>>>> ", contentHeight,dataHeight)
                    const editor = document.getElementsByClassName("ProseMirror")[0];
                    if (editor) {
                        editor.scrollTop = dataHeight;
                    }
                    let conversation = contentHeight - 50;
                    if (conversation < 0) {
                        conversation = 0; // Prevent negative bottom value
                    } 
                    let typingtitleHight = Math.max(contentHeight, 70); 
                    this.$emit('uploaderHight', contentHeight); 
                    this.$emit('typingtitleHight', typingtitleHight); 
                    this.$emit('conversation', conversation); 
                }

                if (updatedContent === '<p></p>' || updatedContent === '') {
                    this.editor.commands.setContent(''); // Clear the content
                    editorContainer.classList.add('is-empty'); // Add empty class
                } else {
                    editorContainer.classList.remove('is-empty'); // Remove empty class
                }
            });
            // Watch for content changes and hide the suggestion box if @ is removed
            this.editor.on('transaction', () => {
                const text = this.editor.getText(); // Get the text content
                if (!text.includes('@') && this.suggestionBox) {
                    this.suggestionBox.style.display = 'none'; // Hide suggestion box if no @ symbol
                }
            });
        },
        methods: {
            // this fun is for to statrt the editor with mention
            onStart(props) {
                const { items, editor } = props;
                
                // Create the suggestion box only once
                if (!this.suggestionBox) {
                    this.suggestionBox = document.createElement('div');
                    this.suggestionBox.classList.add('mention-suggestion-box');
                    document.querySelector('.mention-pos').appendChild(this.suggestionBox); // Append to the body
                }
                
                // console.log('else-if')
                this.suggestionBox.innerHTML = ''; // Clear previous suggestions
                if (items.length > 0) {
                    items.forEach((item) => {
                        const suggestionItem = document.createElement('div');
                        suggestionItem.textContent = item.first_name;
                        suggestionItem.classList.add('mention-suggestion-item');
                        // Add image and text to the suggestion item
                        suggestionItem.innerHTML = `
                            <img src="${item?.profile_picture_path}" alt="${item.first_name}" class="mention-image" />
                            <span>${item?.first_name}  ${item?.last_name}</span>
                        `;
                        suggestionItem.addEventListener('click', () => {
                            this.handleMentionSelect(item); // Handle selection
                        });
                        this.suggestionBox.appendChild(suggestionItem);
                    });

                    // Position the suggestion box
                    this.positionSuggestionBox(editor);
                    this.suggestionBox.style.display = 'block'; // Show the suggestion box
                } else {
                    // If no items, hide the suggestion box
                    this.suggestionBox.style.display = 'none';
                }
                
            },
            // this fun is for to update the editor with mention
            onUpdate(props) {
                const { items, editor } = props;
                // Clear and display the suggestion box with new items
                if (this.suggestionBox) {
                    this.suggestionBox.innerHTML = ''; // Clear previous suggestions
                    if (items.length > 0) {
                        items.forEach((item) => {
                        const suggestionItem = document.createElement('div');
                        suggestionItem.textContent = item.first_name;
                        suggestionItem.classList.add('mention-suggestion-item');
                        suggestionItem.innerHTML = `
                            <img src="${item?.profile_picture_path}" alt="${item.first_name}" class="mention-image" />
                            <span>${item?.first_name} ${item?.last_name}</span>
                        `;
                        suggestionItem.addEventListener('click', () => {
                            this.handleMentionSelect(item); // Handle selection
                        });
                        this.suggestionBox.appendChild(suggestionItem);
                        });

                        // Position the suggestion box
                        this.positionSuggestionBox(editor);
                        this.suggestionBox.style.display = 'block'; // Show the suggestion box
                    } else {
                        // If no items, hide the suggestion box
                        this.suggestionBox.style.display = 'none';
                    }
                }
            },
            // this fun is for to select the editor with mention
            onSelect(props) {
                const { editor, item } = props;
                this.handleMentionSelect(item, editor);
                // console.log('this.suggestionBox',this.suggestionBox)
                // Close the suggestion box after selection
                if (this.suggestionBox) {
                    this.suggestionBox.style.display = 'none'; // Hide the suggestion box
                }
            },
            // Fetch mentions asynchronously based on the query
            async fetchMentions(query) {
                const queryString = typeof query.query === 'string' ? query.query : String(query.query);
                return this.mentions.filter((mention) =>
                    mention.first_name.toLowerCase().includes(queryString.toLowerCase())
                );
            },
            
            updatePlaceholder() {
                if (this.editor) {
                    // Update the placeholder dynamically
                    this.editor.setOptions({
                    extensions: [
                        Placeholder.configure({
                        placeholder: this.newVal ? 'aaaaaaaaaa' : 'bbbbbbbbbbbbbb', // Dynamically set the placeholder
                        emptyNodeClass: 'is-empty',
                        showOnlyWhenEditable: true,
                        includeChildren: true, // Include children in empty state detection
                        filter: (node) => {
                            return node.textContent.trim() === ''; // Avoid whitespace-only content being marked empty
                        }

                        }),
                    ],
                    });
                }
            },
                    
            // Handle the selection of a mention (insert into the editor)
            // handleMentionSelectold(item, editor = this.editor) {
            //     if (!editor) {
            //         console.error('Editor instance is not available');
            //         return;
            //     }
            //     // Ensure the editor is focused before accessing selection
            //     if (!editor.isFocused) {
            //         console.log('Editor is not focused, focusing now...');
            //         editor.view.focus(); // Focus the editor view
            //     }

            //     const selection = editor.state.selection;
            //     const position = selection.from; // Get the current cursor position

            //     // Get the text just before the cursor
            //     let lastAtPosition = -1;
            //     // Iterate backwards from the cursor position to find the last '@'
            //     for (let i = position - 1; i >= 0; i--) {
            //         const char = editor.state.doc.textBetween(i, i + 1);
            //         if (char === '@') {
            //             lastAtPosition = i; // Store the position of the last '@'
            //             break; // Stop once the last '@' is found
            //         }
            //     }
            //     // Debugging logs
            //     console.log('lastAtPosition:', lastAtPosition, 'position:', position);
            //     // If no '@' symbol found before the cursor, do nothing
            //     if (lastAtPosition === -1) {
            //         console.log('No @ symbol found before the cursor');
            //         return;
            //     }
            //     // Determine the text to insert (mention)
            //     const insertText = `@${item.first_name} `;
            //     console.log('Inserting:', insertText, 'at position:', position);

            //     // Ensure valid range for deletion
            //     if (lastAtPosition >= position) {
            //         console.error('Invalid range: lastAtPosition should be less than position');
            //         return;
            //     }
            //     // Create a transaction to replace the range with the new content
            //     const tr = editor.view.state.tr;
            //     // 1. Replace the content between lastAtPosition and position with the new mention
            //     tr.replaceRange(lastAtPosition, position, editor.view.state.schema.text(insertText));
            //     // 2. Apply the transaction
            //     editor.view.dispatch(tr);
            //     // Insert the mention at the current cursor position
            //     editor.chain().focus().insertContent(insertText).run();
            //     // Close the suggestion box after selection
            //     if (this.suggestionBox) {
            //         this.suggestionBox.style.display = 'none'; // Hide the suggestion box
            //     }
            // },

            handleMentionSelect(item, editor = this.editor) {
                if (!editor) {
                    console.error('Editor instance is not available');
                    return;
                }

                // Ensure the editor is focused before accessing the selection
                if (!editor.isFocused) {
                    console.log('Editor is not focused, focusing now...');
                    editor.view.focus(); // Focus the editor view
                }

                const selection = editor.state.selection;
                const position = selection.from; // Get the current cursor position

                // Get the text just before the cursor to find the '@' symbol
                let lastAtPosition = -1;
                for (let i = position - 1; i >= 0; i--) {
                    const char = editor.state.doc.textBetween(i, i + 1);
                    if (char === '@') {
                        lastAtPosition = i;
                        break;
                    }
                }

                // console.log('lastAtPosition:', lastAtPosition, 'position:', position);

                // If no '@' symbol is found, do nothing
                if (lastAtPosition === -1) {
                    console.log('No @ symbol found before the cursor');
                    return;
                }

                // The text to insert into the editor
                const insertText = `@${item.first_name} `;
                // console.log('Inserting:', insertText, 'at position:', position);     

                // Ensure a valid range for replacement
                if (lastAtPosition >= position) {
                    console.error('Invalid range: lastAtPosition should be less than position');
                    return;
                }

                // Use editor chain commands for better integration with the editor state
                try {
                    editor
                        .chain()
                        .focus()
                        .deleteRange({ from: lastAtPosition, to: position }) // Delete the range between '@' and cursor
                        .insertContent(insertText) // Insert the mention text
                        .run();
                } catch (error) {
                    console.error('Error during mention insertion:', error);
                    return;
                }

                // console.log('Mention inserted successfully.');

                // Close the suggestion box after selection
                if (this.suggestionBox) {
                    // Use requestAnimationFrame to ensure DOM updates before closing the box
                    requestAnimationFrame(() => {
                        this.suggestionBox.style.display = 'none'; // Hide the suggestion box
                        // console.log('Suggestion box hidden.');
                    });
                } else {
                    console.warn('Suggestion box reference is not available.');
                }
            },

            // Position the suggestion box near the cursor
            positionSuggestionBox(editor) {
                const { selection } = editor.state;
                if (selection && selection.head !== undefined) {
                    const coords = editor.view.coordsAtPos(selection.head); // Get cursor position
                    if (coords && this.suggestionBox) {
                        // Set the suggestion box position relative to the cursor
                        this.suggestionBox.style.position = 'absolute';
                        this.suggestionBox.style.left = `${coords.left}px`;
                        this.suggestionBox.style.top = `${coords.bottom + 5}px`; // Position it just below the cursor
                        this.suggestionBox.style.width = `${coords.right - coords.left}px`; // Match the width of the cursor
                        this.suggestionBox.style.zIndex = 100; // Ensure it's above other elements
                    }
                }
            },
        },

        beforeDestroy() {
        if (this.editor) {
            this.editor.destroy();
        }
        if (this.suggestionBox) {
            document.body.removeChild(this.suggestionBox); // Remove the suggestion box when the editor is destroyed
        }
        },
    };
</script>
                    
<style>
    .editor-wrapper {
        display: flex;
        flex-direction: column-reverse; /* Reverse the column direction */
        height: 100%; /* Full parent height */
        position: relative;
    }
    .reply-emojis .in-wrap{
        border-radius:24px;
        display: block;
        height: 50px;
        /*background-color: #eeeeee;*/
    }
    .reply-emojis .in-wrap .emoji{
        display: inline-block;
        margin: 5px;
        font-size: 20px;
        cursor: pointer;
    }
    .tiptap-editor {
        position: absolute; /* Or relative to your parent container */
        bottom: 0px; /* Stick to the bottom of the parent container */
        right: 0;
        width: 100%; /* Adjust as needed */
        max-height: 150px; /* Set a maximum height to prevent overflow */
        /* overflow-y: auto; Allow scrolling when max height is reached */
        background-color: #f2f2f2;
        padding: 0px 55px 0px 35px;
        font-family: Arial, sans-serif;
        box-sizing: border-box;
        border:1px solid #dcdcdc;
        /*height: 50px !important;*/
    }

    .ProseMirror {
        width: 100%; /* Adjust as needed */
        max-height: 150px; /* Set a maximum height to prevent overflow */
        overflow-y: auto; /* Allow scrolling when max height is reached */
        font-feature-settings:normal!important;
        box-sizing: border-box;
        padding:11px 0;
    }

    .ProseMirror .is-empty::before {
        content: attr(data-placeholder); /* Placeholder text from the attribute */
        color: #aaa; /* Placeholder text color */
        position: absolute; /* Position it absolutely */
        pointer-events: none; /* Prevent interaction with the placeholder */
        top: 0; /* Align with the top of the editor */
        left: 0; /* Align with the left of the editor */
        padding: 11px; /* Match the padding of the editor */
        font-family: Arial, sans-serif; /* Use the same font for consistency */
    }
    .ProseMirror.is-empty {
        position: relative; /* Required for absolute positioning of the placeholder */
    }

    /* Ensure editor doesn't overflow upwards */
    .tiptap-editor.expanding {
        max-height: none;
    } 

    .tiptap-editor {
        position: absolute; /* Or relative to your parent container */
        bottom: 0px; /* Stick to the bottom of the parent container */
        right: 0;
        width: 100%; /* Adjust as needed */
        max-height: 150px; /* Set a maximum height to prevent overflow */
        /* overflow-y: auto; Allow scrolling when max height is reached */
        background-color: #f2f2f2;
        padding: 0px 55px 0px 35px;
        font-family: Arial, sans-serif;
        box-sizing: border-box;
        border:1px solid #dcdcdc;
        /*height: 50px !important;*/
    }

    /* Style for the mention itself */
    .mention {
        background-color: #e6f7ff; /* Light blue background for mention */
        color: #007bff; /* Blue color for the mention text */
        border-radius: 3px; /* Slight rounding of corners */
        padding: 2px 5px; /* Padding for spacing */
    }

    /* Styling for the mention suggestion box */
    .mention-suggestion-box {
        position: absolute;
        background-color: #ffffff; /* White background */
        border: 1px solid #ccc; /* Light gray border */
        max-height: 200px;
        overflow-y: auto;
        z-index: 100;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2); /* Subtle shadow around the box */
        width: auto !important; /* Fixed width for the suggestion box */
        bottom:22px!important;
        left:20px!important;
        top:auto!important;
    }

    /* Styling for each suggestion item in the suggestion box */
    /* .mention-suggestion-item {
        padding: 8px;
        cursor: pointer;
        font-size: 14px;
    } */

    /* Hover effect on suggestion items */
    
    .mention-suggestion-item {
        display: flex;
        align-items: center;
        padding: 8px;
        cursor: pointer;
        font-size: 14px;
    }

    .mention-suggestion-item img.mention-image {
        width: 30px;
        height: 30px;
        border-radius: 50%; /* Make the image circular */
        margin-right: 10px; /* Add spacing between the image and the text */
    }

    .mention-suggestion-item:hover {
        background-color: #e6f7ff;
        color: #007bff;
    }

    /* Optionally, you can add a "selected" state style */
    .mention-suggestion-item.selected {
        background-color: #cce5ff; /* Light blue background for the selected item */
        color: #0056b3; /* Darker blue for the selected text */
    }

    /* New message module css */



    .chat-input .reply{
        border-radius:20px;
        background-color: transparent!important;;
        height:100%;
    }

    
    .chat-input .tiptap-editor{
        border-radius:20px;
    }
    .chat-input .reply .reply-send{ 
        z-index: 1;
        background-color: #dadada;
        border-radius: 50%;
        right: 4px;
        top: 2px;
        width: 41px;
        height: 41px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }
    .chat-input .reply .reply-send .btn{ 
        padding: 6px 13px!important;
    }
    .tiptap-editor p{
        margin-bottom:0px!important;
    }

        /* Hide the border when the editor is focused */
    .tiptap-editor:focus-within .ProseMirror {
        border: none; /* Remove the border */
    }

    /* Add a border to the editor when it is not focused */
    /*.tiptap-editor .ProseMirror {
    border: 1px solid transparent; 
    }*/

    /* Optional: Add a more prominent border when the editor is focused (if needed) */
    /*.tiptap-editor:focus-within .ProseMirror {
        border: 1px solid transparent; 
    }

    .tiptap-editor:focus-within .ProseMirror p{
        border: 1px solid transparent;
    }*/
    .ProseMirror-focused {
        /*border: 1px solid transparent!important; 
        box-shadow:none!important;*/
        outline:none!important;
    }
</style>
